require('./brokerConvenienceMiFIDTestWizardView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { EmptyState } = require('commonsComponents/emptyState');
const { ContentBox } = require('commonsComponents/contentBox');


// @actions
const PrinterActions = require('actions/contactCenter/printer');
const BrokerMiFIDProductsAction = require('mifid/actions/brokerMiFIDProducts');
const BrokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerConvenienceMiFIDTestStepOmitTestAction = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStepOmitTest');
const BrokerInternalTransferFundsActions = require('actions/brokerInternalTransferFunds');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const BrokerConsultMiFID = require('mifid/actions/brokerConsultMiFID')
// @components
const BrokerAlreadyUnsuccessfullyPerformedMiFIDTest = require('mifid/components/brokerAlreadyUnsuccessfullyPerformedMiFIDTest/brokerAlreadyUnsuccessfullyPerformedMiFIDTest');
const { BrokerSuspendedMiFIDTest } = require('mifid/components/brokerSuspendedMiFIDTest/brokerSuspendedMiFIDTest');
const BrokerExpiredMiFIDTest = require('mifid/components/brokerExpiredMiFIDTest/brokerExpiredMiFIDTest');
const BrokerConvenienceMiFIDTestWizard = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestWizard');
const {
    BrokerConvenienceMiFIDTestStepSuccess
} = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestStepSuccess/brokerConvenienceMiFIDTestStepSuccess');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerConsultMiFIDInfoColumn = require('mifid/components/brokerConsultMiFIDInfoColumn/brokerConsultMiFIDInfoColumn');
const BrokerLastResultMiFIDInfoColumn = require('mifid/components/brokerLastResultMiFIDInfoColumn/brokerLastResultMiFIDInfoColumn');
const BrokerMiFID2DisapprovedTestDisclaimer = require('mifid/components/brokerMiFID2DisapprovedTestDisclaimer/brokerMiFID2DisapprovedTestDisclaimer');
const BrokerMiFID2DisapprovedTestDisclaimerCC = require('mifid/components/brokerMiFID2DisapprovedTestDisclaimerCC/brokerMiFID2DisapprovedTestDisclaimerCC');
const BrokerMiFID2UsPersonBlockingDisclaimer = require('mifid/components/brokerMiFID2UsPersonBlockingDisclaimer/brokerMiFID2UsPersonBlockingDisclaimer');
const { ModalUsPersonBlock } = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');
const BrokerConvenienceTest = require('mifid/components/brokerConvenienceTest/brokerConvenienceTestView');
const BrokerCryptoTestDisclaimer = require('mifid/components/brokerCryptoTest/brokerCryptoTestDisclaimer/brokerCryptoTestDisclaimer');
const BrokerCryptoFrame = require('mifid/components/brokerCryptoTest/brokerCryptoFrame/brokerCryptoFrame');
const BrokerCryptoTest = require ('mifid/components/brokerCryptoTest/brokerCryptoTest/brokerCryptoTest');

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { contactCenterAction } = require('utilities/conditionals/conditionalAction');
const { isRenderStep0, shouldCoherenceControl } = require('mifid/utilities/mifidValidHelper');
const { getUsPersonFeatureFlag } = require('mifid/utilities/mifidFlagUsPersonHelpper');

// @constants
const {
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_CONSULT_MIFID_URL,
    BROKER_CONVENIENCE_MIFID_TEST_MANUAL_ID,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_SUBSCRIPTION,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPV,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_CHANGE,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPA,
    BROKER_CONVENIENCE_MIFID_TEST_FUTURES_PLATFORM_ACCESS,
    BROKER_CONVENIENCE_MIFID_FUND,
    BROKER_CONVENIENCE_MIFID_FUND_SUSCRIBE,
    BROKER_CONVENIENCE_MIFID_ETF,
    BROKER_CONVENIENCE_MIFID_WARRANT,
    BROKER_CONVENIENCE_MIFID_MOTIVE_TAKE_TEST,
    BROKER_CONVENIENCE_MIFID_MOTIVE_SUSPENDED,
    BROKER_CONVENIENCE_MIFID_MOTIVE_EXPIRED,
    BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND,
    BROKER_MIFID_VERSION_1,
    BROKER_MIFID_VERSION_2,
    BROKER_PG_URL
} = require('constants/index');

class BrokerConvenienceMiFIDTestWizardView extends Component {
    constructor(props) {
        super(props);

        this.handleValidateStep = this.handleValidateStep.bind(this);
        this.handleOmitContinue = this.handleOmitContinue.bind(this);
        this.wizardWillCancel = this.wizardWillCancel.bind(this);
        this.wizardWillGoBack = this.wizardWillGoBack.bind(this);
        this.wizardFinish = this.wizardFinish.bind(this);
        this.buildWizard = this.buildWizard.bind(this);
        this.buildWizardSuccess = this.buildWizardSuccess.bind(this);
        this.buildProgressList = this.buildProgressList.bind(this);
        this.buildProgressSection = this.buildProgressSection.bind(this);
        this.buildSideColumn = this.buildSideColumn.bind(this);
        this.buildHelpButton = this.buildHelpButton.bind(this);
        this.getTitleKey = this.getTitleKey.bind(this);
        this.getSubtitle = this.getSubtitle.bind(this);
        this.buildIntermediateScreens = this.buildIntermediateScreens.bind(this);
        this.buildTest = this.buildTest.bind(this);
        this.getTitleKeyByOperation = this.getTitleKeyByOperation.bind(this);
    }

    componentWillMount() {
        const {
            immBrokerConvenienceMiFIDTest,
            resetStepsToInitialState,
            immMyInvestments,
            consultMiFID,
            flagBasedFeatures,
            history
        } = this.props;
        contactCenterAction(this.props.resetPrintedIndicators);
        if(!immBrokerConvenienceMiFIDTest.get('consulting')){
            resetStepsToInitialState();
        }
        if(
            flagBasedFeatures.get('convenience_test_less_score_warning') &&
            !immBrokerConvenienceMiFIDTest.getIn(['operationData', 'isManualTest'])
        ) {
            consultMiFID(history);
        }
        if (!immMyInvestments.get('fetchSuccess') &&
            !immMyInvestments.get('isFetching') &&
            !immMyInvestments.get('errorReceived') &&
            flagBasedFeatures.get('convenience_test_less_score_warning')) {
            this.props.fetchMyInvestments();
        }
    }

    componentDidMount() {
        const { history, immBrokerConvenienceMiFIDTest } = this.props;
        const invalidAccess = !immBrokerConvenienceMiFIDTest.get('started');
        const productId = immBrokerConvenienceMiFIDTest.get('productId');
        const notManualTest = productId !== BROKER_CONVENIENCE_MIFID_TEST_MANUAL_ID;
        const notUsingMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') !== BROKER_MIFID_VERSION_2;

        if (notManualTest && invalidAccess) {
            history.goBack();
        } else if (notManualTest && notUsingMifidv2) {
            this.props.onFetchBrokerMiFIDProduct(productId);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immBrokerConvenienceMiFIDTest, onSetVisibleStep } = nextProps;
        const finished = immBrokerConvenienceMiFIDTest.get('finished');
        const visibleStep = immBrokerConvenienceMiFIDTest.get('visibleStep');
        const immSteps = immBrokerConvenienceMiFIDTest.get('steps');
        const stepsFromZero = visibleStep - 1;
        const immStep = immSteps.get(stepsFromZero);
        if (!finished && immStep.get('valid')) {
            onSetVisibleStep(visibleStep + 1);
        }
    }

    /**
     * @param {numeric} visibleStep
     */
    handleValidateStep(visibleStep) {

        const { onValidateStep } = this.props;
        const stepsFromZero = isRenderStep0() ? visibleStep - 2  : visibleStep - 1;
        onValidateStep(stepsFromZero);
    }

    wizardWillGoBack() {
        this.props.history.push(MYPROFILE_BROKER_CONSULT_MIFID_URL);
    }

    wizardWillCancel() {
        const { history, immBrokerConvenienceMiFIDTest } = this.props;

        const cancelPath = immBrokerConvenienceMiFIDTest.get('cancelPath') || MYPROFILE_BROKER_URL;

        if (!immBrokerConvenienceMiFIDTest.get('isCancelPathAbsolute')) {
            history.replace(cancelPath); // This doesn't consider the domain
        } else {
            window.location.replace(cancelPath); // Redirects to URLs with different hostnames
        }
    }

    wizardFinish() {
        const { immProfileFields, onWizardFinish, history } = this.props;
        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);

        onWizardFinish(clientEmail, history);
    }

    buildLastBreadcrumbItem() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const isOmittingTest = immBrokerConvenienceMiFIDTest.get('operateOmittingTest');
        const doesNotRequiresTest = !immBrokerConvenienceMiFIDTest.get('requiresTest');
        let text;

        if (isOmittingTest) {
            text = formatText('broker-convenienceMifidTestConvenienceOmitTest');
        } else if (doesNotRequiresTest) {
            text = formatText('broker-convenienceMifidTestEndOfOperation');
        } else {
            text = formatText('broker-convenienceMifidTestMifid');
        }

        return { text, url: '' };
    }

    buildBreadcrumb() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const buildedBreadcrumb = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'breadcrumb']);
        const lastBreadcrumbItem = this.buildLastBreadcrumbItem();
        const buildBreadcrumbProductType = this.buildBreadcrumbProductType();

        // Components that start MiFID flow can specify the displayed breadcrumb in
        // brokerConvenienceMiFIDTest.start action as part of operationData argument
        // in a `breadcrumb` key.
        if (buildedBreadcrumb) {
            return [...buildedBreadcrumb.toJS(), lastBreadcrumbItem];
        }

        if (immBrokerConvenienceMiFIDTest.get('consulting')) {
            return [
                {
                    text: formatText('broker-convenienceMifidTestStart'),
                    url: MYPROFILE_BROKER_URL
                },
                {
                    text: formatText('broker-convenienceMifidTestConvenienceTest'),
                    url: MYPROFILE_BROKER_CONSULT_MIFID_URL
                },
                {
                    text: formatText('broker-convenienceMifidTestConsult'),
                    url: ''
                }
            ];
        }

        const productName = immBrokerConvenienceMiFIDTest.get('productName');

        let breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            }
        ];

        if (productName) {
            breadcrumb.push({
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            });
            breadcrumb.push({
                text: productName,
                url: immBrokerConvenienceMiFIDTest.get('productUrl')
            });
            breadcrumb.push(buildBreadcrumbProductType);
        }

        breadcrumb.push(lastBreadcrumbItem);

        return breadcrumb;
    }

    buildBreadcrumbProductType() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const breadcrumbProductType = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'productType']);

        switch (breadcrumbProductType) {
            case BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND: {
                return {
                    text: formatText('broker-internalTransferFundBreadcrumb'),
                    url: immBrokerConvenienceMiFIDTest.getIn(['urlContinueOperation', 0])
                };
            }
            case BROKER_CONVENIENCE_MIFID_FUND_SUSCRIBE: {
                return {
                    text: formatText('broker-convenienceMifidTestSuscribe'),
                    url: immBrokerConvenienceMiFIDTest.getIn(['urlContinueOperation', 0])
                };
            }
            default: {
                return {
                    text: formatText('broker-convenienceMifidTestBuy'),
                    url: immBrokerConvenienceMiFIDTest.getIn(['urlContinueOperation', 0])
                };
            }
        }
    }

    buildWizard() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts, flagBasedFeatures } = this.props;
        const visibleStep = immBrokerConvenienceMiFIDTest.get('visibleStep');
        const immSteps = immBrokerConvenienceMiFIDTest.get('steps');
        const actions = {
            validateStep: this.handleValidateStep,
            setVisibleStep: this.props.onSetVisibleStep,
            setWillCancel: this.wizardWillCancel,
            setWillGoBack: this.wizardWillGoBack,
            finish: this.wizardFinish
        };

        return (
            <BrokerConvenienceMiFIDTestWizard
                visibleStep={visibleStep}
                immSteps={immSteps}
                actions={actions}
                isConsulting={immBrokerConvenienceMiFIDTest.get('consulting')}
                onOmitTest={this.handleOmitContinue}
            />
        );
    }

    buildWizardSuccess() {
        const {
            immBrokerConvenienceMiFIDTest,
            flagBasedFeatures,
            onRetakeTest,
            verifyDocumentSigned,
            history,
            requestCryptoDocumentation
        } = this.props;
        const usPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
        const blockingDisclaimer = !!usPersonDisclaimers && usPersonDisclaimers.find((disclaimer) => {
            return disclaimer.get('id') === 'D7';
        });
        const usPersonflag = getUsPersonFeatureFlag(
            immBrokerConvenienceMiFIDTest.get("operationType")
        );
        const isCryptoTest = immBrokerConvenienceMiFIDTest.getIn(['test', 'isCryptoTest']);

        if (isCryptoTest) {
            return (
                    <BrokerCryptoTestDisclaimer
                        history={history}
                        retakeTest={onRetakeTest}
                        immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                        verifyDocumentSigned={verifyDocumentSigned}
                        requestCryptoDocumentation={requestCryptoDocumentation}
                    />
            );
        }

        if (
            !!blockingDisclaimer &&
            !!usPersonflag &&
            flagBasedFeatures.get(usPersonflag)
        ) {
            return (
                <BrokerMiFID2UsPersonBlockingDisclaimer
                    immUsPersonDisclaimer={blockingDisclaimer}
                    immBrokerConvenienceMiFIDTest={
                        immBrokerConvenienceMiFIDTest
                    }
                />
            );
        }
        return (
            <BrokerConvenienceMiFIDTestStepSuccess
                onContinueToInternalTransferFund={this.props.onContinueInternalTransferFundFromMifid}
                isIntermediateScreen={false}
            />
        );
    }

    handleOmitContinue() {
        const clientEmail = PersonalDataHelper.getEmail(this.props.immProfileFields);
        this.props.onOmit();
        this.props.onOmitContinue(clientEmail, this.props.history);
    }

    buildProgressList(immStep) {
        const immSummaries = immStep.get('summaryDescription');
        const description = immSummaries.map((summary, key) =>
            (<p key={key} className="convenience-mifid-test-wizard-view__section-light">
                {summary}
            </p>)
        );

        return (
            <div className="media convenience-mifid-test-wizard-view__media">
                <div className="media-left">
                    <i className="media-object icon-tilde convenience-mifid-test-wizard-view__summary-icon" />
                </div>
                <div className="media-body">
                    <h4 className="media-heading convenience-mifid-test-wizard-view__test-summary-header">
                        {immStep.get('summaryTitle')}
                    </h4>
                    {description}
                </div>
            </div>
        );
    }

    buildProgressSection(immValidSteps) {
        if (immValidSteps.size > 0) {
            const progressList = immValidSteps.map((immStep) => this.buildProgressList(immStep));
            return (
                <div className="col-xs-12 grid-view--variable-cell-separation">
                    <OKSectionBox className="convenience-mifid-test-wizard-view__test-summary">
                        <h4>
                            <FormattedText className="convenience-mifid-test-wizard-view__test-summary-title"
                                value="broker-convenienceMifidTestSummary"
                            />
                        </h4>
                        {progressList}
                    </OKSectionBox>
                </div>
            );
        }
    }

    buildSideColumn() {
        const { immBrokerConvenienceMiFIDTest, immProfileFields } = this.props;
        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const immSteps = immBrokerConvenienceMiFIDTest.get('steps');
        const immValidSteps = immSteps.filter(immStep => {
            return immStep.get('valid') && immStep.get('summaryDescription').size > 0
        });
        const fecha = immBrokerConvenienceMiFIDTest.get('fecha');
        const evaluationDescription = immBrokerConvenienceMiFIDTest.get('evaluationDescription');

        if (immBrokerConvenienceMiFIDTest.get('consulting')) {
            return (
                <BrokerLastResultMiFIDInfoColumn
                    dateLastPerformedTest={fecha}
                    evaluationDescription={evaluationDescription}
                />
            );
        }

        const progressSection = this.buildProgressSection(immValidSteps);
        let consultMiFIDColumn;
        let omitTestSection;

        if (
            immBrokerConvenienceMiFIDTest.get('productId') ===
            BROKER_CONVENIENCE_MIFID_TEST_MANUAL_ID
        ) {
            consultMiFIDColumn = (
                <div className={`col-xs-12 ${immValidSteps.size > 0 ? 'grid-view--fix-cell-separation' : 'grid-view--variable-cell-separation'}`}>
                    <BrokerConsultMiFIDInfoColumn clientEmail={clientEmail} isConsult={false} />
                </div>
            );
        } else {
            omitTestSection = (
                <div className="col-xs-12 grid-view--fix-cell-separation">
                    <OKSectionBox>
                        <section
                            key="convenienceMiFID_p1"
                            className="convenience-mifid-test-wizard-view__section-light"
                        >
                            <div>
                                <section
                                    key="transferStep1"
                                    className="convenience-mifid-test-wizard-view__paragraph"
                                >
                                    <span>
                                        {formatText("broker-convenienceMifidTestResultByMail")}
                                    </span>
                                </section>
                            </div>
                        </section>
                        <section className="convenience-mifid-test-wizard-view__section-light">
                            <div>
                                {[formatText('broker-convenienceMifidTestOpenBankRecommendation')]}
                            </div>
                            <div className="broker-suspended-mifid-test__button">
                                <OKLink modifier="complementary" onClick={this.handleOmitContinue}>
                                    <FormattedText value="broker-convenienceMifidTestSuspendedSecondaryButton"/>
                                </OKLink>
                            </div>
                        </section>
                    </OKSectionBox>
                </div>
            );
        }

        return (
            <div>
                <div className="row">
                    {progressSection}
                    {consultMiFIDColumn}
                    {omitTestSection}
                </div>
            </div>
        );
    }

    buildAlreadyUnsuccessfullyPerformedMifidTest() {
        return (
            <BrokerAlreadyUnsuccessfullyPerformedMiFIDTest
                onOmmitTest={this.props.onOmit}
                onGoBackToTest={this.props.onResetTest}
            />
        );
    }

    buildHelpButton() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts } = this.props;
        const productId = immBrokerConvenienceMiFIDTest.get('productId');
        const requiresTest = immBrokerMiFIDProducts.getIn(['products', productId, 'requiresTest']);
        const finished = immBrokerConvenienceMiFIDTest.get('finished');
        const consulting = immBrokerConvenienceMiFIDTest.get('consulting');

        if (consulting) {
            return (
                <OKButton inverse={true} leftIcon="icon-anterior" modifier="ghost" to={MYPROFILE_BROKER_CONSULT_MIFID_URL}
                >
                    <FormattedText value="broker-convenienceMifidTestConsultTestBackLink" />
                </OKButton>
            );
        }

        if (requiresTest && !finished) {
            return (
                <OKButton inverse={true} leftIcon="icon-informacion" modifier="ghost" to="">
                    <FormattedText value="broker-helpText" />
                </OKButton>
            );
        }
    }

    buildMiFID2IntermediateScreen() {
        const {
            immBrokerConvenienceMiFIDTest,
            flagBasedFeatures,
            onMiFIDResultDisplayed,
            onRetakeTest,
            verifyDocumentSigned,
            history,
            requestCryptoDocumentation,
        } = this.props;
        const cancelPath = immBrokerConvenienceMiFIDTest.get('cancelPath') || MYPROFILE_BROKER_URL;
        const isCancelPathAbsolute = immBrokerConvenienceMiFIDTest.get('isCancelPathAbsolute');
        const disclaimer = ""; // @hardcoded (franco.montenegro) Confirm if disclaimer is always empty
        const lastExecutionTimestamp = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'lastExecutionTimestamp']);
        const firstTimePerformingTest = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'firstTimePerformingTest']);
        const notDisclaimer = !!immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']) &&
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']).size === 0;
        const onlyWarrantDisclaimer = !!immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']) &&
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']).size === 1 &&
            immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers', 0, 'id']) === 'W1';
        const usPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
        const blockingDisclaimer = !!usPersonDisclaimers && usPersonDisclaimers.find((disclaimer) => {
            return disclaimer.get('id') === 'D7';
        });
        const usPersonflag = getUsPersonFeatureFlag(
            immBrokerConvenienceMiFIDTest.get("operationType")
        );
        const isCryptoTest = immBrokerConvenienceMiFIDTest.getIn(['test', 'isCryptoTest']);

        if (isCryptoTest) {
            return (
                <BrokerCryptoTestDisclaimer
                    history={history}
                    onRetakeTest={onRetakeTest}
                    immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                    verifyDocumentSigned={verifyDocumentSigned}
                    requestCryptoDocumentation={requestCryptoDocumentation}
                />
            );
        }

        if (
            !!blockingDisclaimer &&
            !!usPersonflag &&
            flagBasedFeatures.get(usPersonflag)
        ) {
            return (
                <BrokerMiFID2UsPersonBlockingDisclaimer
                    immUsPersonDisclaimer={blockingDisclaimer}
                    immBrokerConvenienceMiFIDTest={
                        immBrokerConvenienceMiFIDTest
                    }
                />
            );
        }
        const reason = immBrokerConvenienceMiFIDTest.getIn(['test', 'testToEvaluate', 'reason'])
        if (notDisclaimer || onlyWarrantDisclaimer || reason === '4'){
            return(
                <BrokerSuspendedMiFIDTest
                    cancelPath={cancelPath}
                    isCancelPathAbsolute={isCancelPathAbsolute}
                    disclaimerText={disclaimer}
                    lastExecutionTimestamp={lastExecutionTimestamp}
                    onContinueOperation={onRetakeTest}
                    onOmmitOperation={this.handleOmitContinue}
                    firstTimePerformingTest={firstTimePerformingTest}
                    onMiFIDResultDisplayed={onMiFIDResultDisplayed}
                    history={this.props.history}
                />
            );
        }

        return (
            <BrokerConvenienceMiFIDTestStepSuccess
                onContinueToInternalTransferFund={this.props.onContinueInternalTransferFundFromMifid}
                onRetakeTest={onRetakeTest}
                isIntermediateScreen
            />
        );
    }

    isLoading() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts } = this.props;
        const usingMiFIDv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
        const productId = immBrokerConvenienceMiFIDTest.get('productId');

        if (usingMiFIDv2) {
            return false;
        }

        return immBrokerMiFIDProducts.getIn(['products', productId, 'loading'], true);
    }

    fetchInformation() {
        const {
            immBrokerConsultMiFID,
            immMyInvestments,
            fetchMyInvestments,
            consultMiFID,
            history
        } = this.props
        if (immBrokerConsultMiFID.get('error')) {
            consultMiFID(history);
        }
        if (immMyInvestments.get('errorReceived')) {
            fetchMyInvestments();
        }
    }

    buildContent() {
        const {
            immBrokerConvenienceMiFIDTest,
            immMyInvestments,
            immBrokerConsultMiFID,
            immProfileFields,
            onReviewDisapprovedTest,
            onContinueWithDisapprovedTest,
            flagBasedFeatures
        } = this.props;
        const usingMiFIDv2 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_2;
        const consulting = immBrokerConvenienceMiFIDTest.get('consulting');
        const productId = immBrokerConvenienceMiFIDTest.get('productId');
        const manualTest = productId === BROKER_CONVENIENCE_MIFID_TEST_MANUAL_ID;
        const requiresTest = manualTest || immBrokerConvenienceMiFIDTest.get('requiresTest');
        const retakeTest = immBrokerConvenienceMiFIDTest.get('retakeTest');
        const skipIntermediateScreens = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'skipIntermediateScreens'])
        const loadingProduct = this.isLoading();
        const coherenceControl = shouldCoherenceControl();
        const myInvesmentLoading = flagBasedFeatures.get('convenience_test_less_score_warning') ? immMyInvestments.get('isFetching') : false;
        const myInvesmentError = flagBasedFeatures.get('convenience_test_less_score_warning') ? immMyInvestments.get('errorReceived') : false;
        let content;
        if (
            (!manualTest && !consulting && loadingProduct) ||
            myInvesmentLoading ||
            immBrokerConsultMiFID.get('loading')
        ) {
            content = (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            );
        } else if (myInvesmentError || !!immBrokerConsultMiFID.get('error')){
            const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');
            const retryButton = (
                <OKButton onClick={() => this.fetchInformation()}>
                    <FormattedText value="broker-retry" />
                </OKButton>
            );
            content = (
                <ContentBox customClassName="broker-general-view__robo-error">
                    <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-wealth"/>
                </ContentBox>
            );
        } else if (
            immBrokerConvenienceMiFIDTest.get('disaprovedCurrentTest')
            && !immBrokerConvenienceMiFIDTest.get('continueWithDisapproved')
            && immBrokerConvenienceMiFIDTest.get('hasRoboPortfolio')
            && coherenceControl
        ) {
            if(__CONTACT_CENTER__){
                content = (
                    <BrokerMiFID2DisapprovedTestDisclaimerCC
                        immProfileFields={immProfileFields}
                        onReviewDisapprovedTest={onReviewDisapprovedTest}
                        onContinueWithDisapprovedTest={onContinueWithDisapprovedTest}
                    />
                );
            } else{
                content = (
                    <BrokerMiFID2DisapprovedTestDisclaimer
                        immBrokerConsultMiFID={immBrokerConsultMiFID}
                    />
                );
            }
        }else if (
            !consulting &&
            (!requiresTest || immBrokerConvenienceMiFIDTest.get('finished'))
        ) {
            content = this.buildWizardSuccess();
        } else if (manualTest || retakeTest || skipIntermediateScreens) {
            content = this.buildTest();
        } else if (usingMiFIDv2) {
            content = this.buildMiFID2IntermediateScreen();
        } else {
            content = this.buildIntermediateScreens();
        }
        return content;
    }

    buildIntermediateScreens() {
        const {
            immBrokerConvenienceMiFIDTest,
            immBrokerMiFIDProducts,
            resetStepsToInitialState,
            onMiFIDResultDisplayed
        } = this.props;
        if(!immBrokerConvenienceMiFIDTest.get('consulting')){
            resetStepsToInitialState();
        }
        const productId = immBrokerConvenienceMiFIDTest.get('productId');
        const motive = immBrokerMiFIDProducts.getIn(['products', productId, 'motive']);
        const disclaimer = immBrokerMiFIDProducts.getIn(
            ['products', productId, 'disclaimer']
        );
        const alreadyPerformedDate = immBrokerMiFIDProducts.getIn(
            ['products', productId, 'date']
        );
        const lastExecutionTimestamp = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'lastExecutionTimestamp']);
        const cancelPath = immBrokerConvenienceMiFIDTest.get('cancelPath') || MYPROFILE_BROKER_URL;
        const isCancelPathAbsolute = immBrokerConvenienceMiFIDTest.get('isCancelPathAbsolute');

        let screen;
        switch (motive) {
            case BROKER_CONVENIENCE_MIFID_MOTIVE_SUSPENDED:
                screen = (
                    <div className="col-xs-12">
                        <BrokerSuspendedMiFIDTest
                            cancelPath={cancelPath}
                            isCancelPathAbsolute={isCancelPathAbsolute}
                            disclaimerText={disclaimer}
                            lastExecutionTimestamp={lastExecutionTimestamp}
                            onContinueOperation={this.props.onRetakeTest}
                            onOmmitOperation={this.handleOmitContinue}
                            onMiFIDResultDisplayed={onMiFIDResultDisplayed}
                        />
                    </div>
                );
                break;
            case BROKER_CONVENIENCE_MIFID_MOTIVE_EXPIRED:
                screen = (
                    <div className="col-xs-12">
                        <BrokerExpiredMiFIDTest
                            cancelPath={cancelPath}
                            isCancelPathAbsolute={isCancelPathAbsolute}
                            disclaimerText={disclaimer}
                            date={alreadyPerformedDate}
                            onContinueOperation={this.props.onRetakeTest}
                            onOmmitOperation={this.handleOmitContinue}
                        />
                    </div>
                )
                break;
            case BROKER_CONVENIENCE_MIFID_MOTIVE_TAKE_TEST:
            default:
                screen = this.buildTest();
        }

        return screen;
    }

    buildTest() {
        const { immBrokerConvenienceMiFIDTest } = this.props;
        const isCryptoTest = immBrokerConvenienceMiFIDTest.getIn(['test', 'isCryptoTest']);
        return isCryptoTest ? <BrokerCryptoTest history={this.props.history} /> : <BrokerConvenienceTest history={this.props.history} />;
    }

    getTitleKey() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts } = this.props;
        const productId = immBrokerConvenienceMiFIDTest.get('productId');
        const manualTest = productId === BROKER_CONVENIENCE_MIFID_TEST_MANUAL_ID;
        const requiresTest = manualTest || immBrokerConvenienceMiFIDTest.get('requiresTest');
        const operateOmittingTest = immBrokerConvenienceMiFIDTest.get('operateOmittingTest');
        const operation = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'productType']);
        const isUsingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;
        const isLoadingProductOfMifid1 = immBrokerMiFIDProducts.getIn(['products', productId, 'loading'], true);
        const isNotManualTest = !manualTest;
        const retakeTest = immBrokerConvenienceMiFIDTest.get('retakeTest');
        const skipIntermediateScreens = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'skipIntermediateScreens']);
        const isConsulting = immBrokerConvenienceMiFIDTest.get('consulting');
        const isPerformingTest = manualTest || retakeTest || skipIntermediateScreens;
        const finishedTest = immBrokerConvenienceMiFIDTest.get('finished');

        if (isConsulting) {
            return 'broker-convenienceMifidTestConsultTest';
        } else if (isUsingMifidv1 && isNotManualTest && isLoadingProductOfMifid1) {
            return 'broker-convenienceMifidTestPerformTest';
        } else if (operateOmittingTest) {
            return 'broker-convenienceMifidTestConvenienceOmitTest';
        } else if (finishedTest) {
            return this.getTitleKeyByOperation(operation, 'broker-convenienceMifidTestEndOfOperation');
        } else if (requiresTest && !isPerformingTest) {
            return this.getTitleKeyByOperation(operation, 'broker-convenienceMifidTestMifid');
        } else if (isPerformingTest) {
            return 'broker-convenienceMifidTestPerformTest';
        } else if (requiresTest) {
            return this.getTitleKeyByOperation(operation, 'broker-convenienceMifidTestConvenienceTest');
        } else {
            return 'broker-convenienceMifidTestEndOfOperation';
        }
    }

    getTitleKeyByOperation(operation, defaultTitleKey) {
        switch (operation) {
            case BROKER_CONVENIENCE_MIFID_FUND:
                return 'broker-hireInvestmentMiFIDTitle';
            case BROKER_CONVENIENCE_MIFID_TEST_FUTURES_PLATFORM_ACCESS:
                return 'broker-accessFuturesPlatformMiFIDTitle';
            case BROKER_CONVENIENCE_MIFID_ETF:
                return 'broker-buyETFsMiFIDTitle';
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY:
                return 'broker-buyRightsMiFIDTitle';
            case BROKER_CONVENIENCE_MIFID_WARRANT:
                return 'broker-buyWarrantsMiFIDTitle';
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_SUBSCRIPTION:
                return 'broker-subscriptionMiFIDTitle';
            case BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND:
                return 'broker-internalTransferFundMiFIDTitle';
        }

        return defaultTitleKey;
    }

    getSubtitle() {
        const { immBrokerConvenienceMiFIDTest } = this.props;

        if (immBrokerConvenienceMiFIDTest.get('operateOmittingTest')) {
            return '';
        }

        switch (immBrokerConvenienceMiFIDTest.getIn(['operationData', 'productType'])) {
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_SUBSCRIPTION:
                return formatText('broker-capitalImprovement');
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY:
                return formatText('broker-capitalImprovement');
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPV:
                return formatText('corporatesOperations-descriptionProccessOPV');
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_CHANGE:
                return formatText('corporatesOperations-descriptionProccessExchange');
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPA:
                return formatText('corporatesOperations-descriptionProccessOPA');
            default:
                return '';
        }
    }

    buildFirstTimeModal() {
        const { immBrokerConvenienceMiFIDTest, hideFirstTimePopUp } = this.props;
        const content = (
            <React.Fragment>
                <div className="convenience-mifid-test-wizard-view__first-time-modal-content">
                    <FormattedText value="broker-convenienceMifidFirstTimeModal_Content" />
                </div>
            </React.Fragment>
        );

        const footer = (
            <div className="convenience-mifid-test-wizard-view__first-time-modal-footer">
                <OKButton onClick={hideFirstTimePopUp}>
                    <FormattedText value="broker-convenienceMifidFirstTimeModal_CTA" />
                </OKButton>
            </div>
        );

        return (
            <OKModal
                title={formatText("broker-convenienceMifidFirstTimeModal_Title")}
                contentFooter={footer}
                content={content}
                isOpen={immBrokerConvenienceMiFIDTest.get('showFirsTimePopUp')}
                onCloseCallback={hideFirstTimePopUp}
                footerType={null}
                titleAlignment={'center'}
                customCloseButton={<div/>}
            />
        );
    }

    render() {
        const mappingBreadcrumb = this.buildBreadcrumb();
        const helpIconAndText = this.buildHelpButton();
        const {immScreen} = this.props
        const titleKey = this.getTitleKey();
        const subtitleLeft = this.getSubtitle();
        const content = this.buildContent();
        const firstTimeModal = this.buildFirstTimeModal();

        const { flagBasedFeatures, immBrokerConvenienceMiFIDTest } = this.props;
        const isCryptoTest = immBrokerConvenienceMiFIDTest.getIn(['test', 'isCryptoTest']);
        const ffUsPersonConvenienceTest = flagBasedFeatures.get('wealth_convenience_test_us_person');
        const contentToRender = isCryptoTest ? (
            <div>
                {content}
            </div>
        ) : (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                isSubtitleLeftCapital={false}
                                finalTitle={getFinalTitle(titleKey)}>
                                {helpIconAndText}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            {firstTimeModal}
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        )
        return (
            <ModalUsPersonBlock
                children={immScreen && immScreen.get("headerIsVisible") ? contentToRender : content}
                featureFlag={ffUsPersonConvenienceTest}
                titleKey={'us_person_popup-convenience_test_title'}
                description={'us_person_popup-convenience_test_message'}
                buttonClick={() => this.props.history.push(BROKER_PG_URL)}
            />
        );
    }
}

BrokerConvenienceMiFIDTestWizardView.propTypes = {
    flagBasedFeatures: PropTypes.object,
    onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immBrokerConsultMiFID: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    immBrokerCorporatesOperations: PropTypes.object.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onWizardFinish: PropTypes.func.isRequired,
    onOmit: PropTypes.func.isRequired,
    onResetTest: PropTypes.func.isRequired,
    onOmitContinue: PropTypes.func.isRequired,
    onRetakeTest: PropTypes.func.isRequired,
    onContinueInternalTransferFundFromMifid: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func,
    onMiFIDResultDisplayed: PropTypes.func,
    hideFirstTimePopUp: PropTypes.func,
    resetStepsToInitialState: PropTypes.func.isRequired,
    immScreen: PropTypes.object.isRequired,
    verifyDocumentSigned: PropTypes.func,
};

module.exports.constructor = BrokerConvenienceMiFIDTestWizardView;
module.exports.BrokerConvenienceMiFIDTestWizardView = connect(
    state => ({
        immScreen: state.screen,
        flagBasedFeatures: state.flagBasedFeatures,
        immProfileFields: state.profile,
        immBrokerConsultMiFID: state.brokerConsultMiFID,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts,
        immProductFile: state.brokerProductFile,
        immBrokerCorporatesOperations: state.brokerCorporatesOperations,
        immMyInvestments: state.brokerMyInvestments,

    }),
    {
        onFetchBrokerMiFIDProduct: BrokerMiFIDProductsAction.fetchMiFIDProduct,
        resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
        onValidateStep: BrokerConvenienceMiFIDTestActions.validateStep,
        onSetVisibleStep: BrokerConvenienceMiFIDTestActions.setVisibleStep,
        onWizardFinish: BrokerConvenienceMiFIDTestActions.finish,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        onOmit: BrokerConvenienceMiFIDTestActions.omit,
        onResetTest: BrokerConvenienceMiFIDTestActions.reset,
        onOmitContinue: BrokerConvenienceMiFIDTestStepOmitTestAction.confirm,
        onRetakeTest: BrokerConvenienceMiFIDTestActions.retakeTest,
        onContinueInternalTransferFundFromMifid: BrokerInternalTransferFundsActions.continueInternalTransferFundFromMifid,
        resetStepsToInitialState: BrokerConvenienceMiFIDTestActions.resetStepsToInitialState,
        onReviewDisapprovedTest: BrokerConvenienceMiFIDTestActions.reviewDisapprovedTest,
        onContinueWithDisapprovedTest: BrokerConvenienceMiFIDTestActions.continueWithDisapprovedTest,
        consultMiFID: BrokerConsultMiFID.consultMiFID,
        onMiFIDResultDisplayed: BrokerConvenienceMiFIDTestActions.resultDisplayed,
        hideFirstTimePopUp: BrokerConvenienceMiFIDTestActions.hideFirstTimePopUp,
        verifyDocumentSigned: BrokerConvenienceMiFIDTestActions.verifyDocumentSigned,
        requestCryptoDocumentation: BrokerConvenienceMiFIDTestActions.requestCryptoDocumentation,
    }
)(withRouter(BrokerConvenienceMiFIDTestWizardView));
